import CardWithArrowLink from 'components/shared/CardWithArrowLink'
import EventCardContent from 'components/shared/CardWithArrowLink/EventCardContent'

const ReviewCard = ({ className, item, ...props }) => (
  <CardWithArrowLink className={className}>
    <EventCardContent eventButtonText={props.eventButtonText} {...item} />
  </CardWithArrowLink>
)

export default ReviewCard
